import { Box, Button, Divider, Grid, Paper, TextField, Typography } from '@mui/material';
import { useState, useEffect } from 'react';
import { Remove, Add } from '@mui/icons-material';
import { RISR, Recomendacoes } from '../../../../services/api/reports/ReportsServicesRisr';

interface MonitoringRiseProps {
    dataRisr?: RISR;
    onDataChange: (data: Recomendacoes[]) => void;
}

export const RecommendationRisr = ({ dataRisr, onDataChange }: MonitoringRiseProps) => {
    const [data, setData] = useState<Recomendacoes[]>([{ prazo: '', recomendacao: '' }]);

    useEffect(() => {
        if (dataRisr?.recomendacoes && Object.keys(dataRisr.recomendacoes).length > 0) {
            setData(dataRisr.recomendacoes);
        }
    }, [dataRisr]);

    // useEffect(() => {
    //     onDataChange(data);
    // }, [data]);

    const handleAdd = () => {
        const newItem: Recomendacoes = { prazo: '', recomendacao: '' };
        setData(prevDataSteps => [...prevDataSteps, newItem]);
    };

    const handleRemove = () => {
        if (data.length > 1) {
            setData(prevDataSteps => prevDataSteps.slice(0, -1));
        }
    };

    const handleMonitoringChange = (index: number, fieldName: keyof Recomendacoes, value: string) => {
        const updatedData = [...data];
        updatedData[index][fieldName] = value;
        setData(updatedData);
        onDataChange(data);
    };

    return (
        <Box>
            <Box padding={1}>
                <Grid container>
                    <Grid item xs={12} marginBottom={1}>
                        <Typography variant='h5'>Recomendações</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Remove />}
                            onClick={handleRemove}
                            disabled={data.length <= 1} // Desabilita se houver apenas um item
                        >
                            Remover
                        </Button>
                    </Grid>
                    <Grid item xs={6} display="flex" justifyContent="center">
                        <Button
                            startIcon={<Add />}
                            onClick={handleAdd}
                        >
                            Adicionar
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Box>
                {data.map((item, index) => (
                    <Box key={index} padding={1}>
                        <Box padding={1} component={Paper} variant='outlined' sx={{ borderRadius: '20px' }}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        label='Prazo'
                                        value={item.prazo?.toString().substring(0, 10)}
                                        onChange={(e) => handleMonitoringChange(index, 'prazo', e.target.value)}
                                        id='prazo'
                                        fullWidth
                                        type='date'
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        required
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        label='Recomendação'
                                        value={item.recomendacao}
                                        onChange={(e) => handleMonitoringChange(index, 'recomendacao', e.target.value)}
                                        id='recomendacao'
                                        fullWidth
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};
